export function ucWords(str: string): string {
  return str
    .toLowerCase()
    .replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function(s: string) {
      return s.toUpperCase();
    });
}
